import $ from 'jquery';

export default class ThemeBuilder {
    /**
     * Constructor.
     *
     * @return {Void}
     */
    constructor() {
        this._$ui = {};
        var that = this;

        // Wait for DOM load and init all.
        $(() => {
            that._$ui.createForm = $('#createForm');
            that.Modal = null;
            $('body')
                .on('click', '.opd-create-new-btn', that.addNew.bind(that))
                .on('click', '.opd-edit-theme-builder', that.edit.bind(that))
                .on('click', '.opd-save-theme-builder-btn', that.formSubmit.bind(that))
                .on('click', '.opd-delete', that.delete.bind(that))
        })
    }

    /**
     * Opens dialog when click on "Use This Template" Button
     *
     * @param e
     * @return {Void}
     */
    addNew(e) {
        e.preventDefault();

        let _this = this;
        let $target = $(e.currentTarget);
        let dialogOptions = window.OP3General.dialogOptions;

        _this.Modal = $.dialog(Object.assign(dialogOptions, {
            theme: 'optimizepress',
            title: 'Create New',
            content: () => {
                let options = {
                    adminUrl: location.href,
                    type: $target.data('type')
                };

                return _this.getAddNewForm(options);
            },
        }));
    }

    /**
     * Opens dialog when click on "Use This Template" Button
     *
     * @param e
     * @return {Void}
     */
    edit(e) {
        e.preventDefault();

        let _this = this;
        let $target = $(e.currentTarget);
        let dialogOptions = window.OP3General.dialogOptions;
        let id = $(e.currentTarget).data('id');

        $.ajax({
            url: OpsScriptData.opd_api_url + 'theme-builder',
            data: {
                id: id,
                _wpnonce: window.OpsScriptData.nonce
            },
            method: 'get',
            dataType: 'json',
        }).done(function(response) {
            _this.Modal = $.dialog(Object.assign(dialogOptions, {
                theme: 'optimizepress',
                title: 'Edit',
                content: () => {
                    let options = {
                        adminUrl: $target.attr('href'),
                        contentId: id,
                        type: $target.data('type'),
                        action: 'edit',
                        submitText: 'Save',
                        contentData: response.data
                    };

                    return _this.getAddNewForm(options);
                },
            }));
        }).fail(function(response) {
            window.OPDashboard.Helpers.notify(response.responseJSON.message, "error");
        });
    }

    /**
     * Form HTML that is submitted upon creating new Rule
     *
     *
     * @param {Array} options
     * @return {String}
     */
    getAddNewForm(options) {
        const defaultOptions = {
            action: 'create',
            contentId: null,
            contentData: null,
            adminUrl: null,
            nonceValue: null,
            templateUid: null,
            fieldTitle: 'Title',
            fieldPlaceholder: 'Enter Title',
            submitText: 'Create',
            submittingText: 'Saving ...',
            locationsTitle: 'Location',
            requestTypes: [
                {'id': 'post', 'title': 'POST'},
                {'id': 'json', 'title': 'JSON'},
            ],
            locations: [
                {'id': 'everywhere', 'title': 'Everywhere'},
                {'id': 'single.all', 'title': 'All Singles'},
                {'id': 'single.posts', 'title': 'Posts'},
                {'id': 'single.pages', 'title': 'Pages'},
                {'id': 'single.media', 'title': 'Media'},
                {'id': 'single.funnels', 'title': 'Funnels'},
                {'id': 'single.courses', 'title': 'Courses'},
                {'id': 'archives.all', 'title': 'All Archives'},
                {'id': 'archives.taxonomy', 'title': 'Taxonomy Archives'},
                {'id': 'archives.date', 'title': 'Date Archives'},
                {'id': 'archives.author', 'title': 'Author Archives'},
                {'id': 'archives.post.type', 'title': 'Post Type Archives'},
                {'id': 'archives.post', 'title': 'Post Archives'},
                {'id': 'notfound', 'title': '404 Not Found'},
                {'id': 'search.results', 'title': 'Search Results'},
            ],
        };

        options = {...defaultOptions, ...options};

        return `
            <div class="ops-container-fluid">
                <form class="ops-form ops-form-single-submit" id="createForm" method="post" action="${options.adminUrl}">
                    <input type="hidden" name="action" value="${options.action}">
                    <input type="hidden" name="type" value="${options.type}">
                    <input type="hidden" name="contentId" value="${options.contentId ? options.contentId : ''}">
                    <div class="ops-row">
                        <div class="ops-col-12">
                            <div class="ops-form-group">
                                <label for="title">${options.fieldTitle}</label>
                                <input id="title" type="text" name="name" value="${options.contentData ? options.contentData.post_title : ''}" placeholder="${options.fieldPlaceholder}" class="ops-form-control" required>
                            </div>
                        </div>
                        <div class="ops-col-12">
                            <div class="ops-form-group">
                                <label for="location">${options.locationsTitle}</label>
                                <select id="location" "name="location" class="ops-form-control" required style="max-width: 100%;font-size: 15px;line-height:23px;width:100% !important">
                                    ${options.locations.map((item, i) => `
                                        <option value="${item.id}" ${(options.contentData && options.contentData.location === item.id) ? 'selected' : ''}>${item.title}</option>
                                    `.trim()).join('')}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="opui-form-actions">
                        <a class="opui-btn opui-btn-primary opd-save-theme-builder-btn">
                            <span class="opui-spinner opui-spinner-border opui-text-light opui-mr-2"></span>
                            <span class="opui-btn-saving-label">${options.submittingText}</span>
                            <span class="opui-btn-label">Save ${options.type.charAt(0).toUpperCase() + options.type.slice(1)}</span>
                        </a>
                    </div>
                </form>
            </div>`;
    }

    /**
     * Submit form
     */
    formSubmit(e) {
        e.preventDefault();

        let $form = $(e.currentTarget.closest('form'));

        // trigger browser validation
        if (! $form[0].reportValidity())
            return false;

        let action = $form.find('[name="action"]').val();
        let title = $form.find('#title').val();
        let location = $form.find('#location :selected').val();
        let type = $form.find('[name="type"]').val();
        let id = null;

        if (action === "edit") {
            id = $form.find('[name="contentId"]').val();
        }

        // disable button after click
        let $button = $(e.currentTarget);
        $button.find(".opui-spinner").attr("style", "display: inline-block !important");
        $button.find(".opui-btn-saving-label").attr("style", "display: inline-block !important");
        $button.find(".opui-btn-label").attr("style", "display: none !important");
        $button.attr("disabled", "disabled");
        $button.css('opacity', '0.4');

        $.ajax({
            url: OpsScriptData.opd_api_url + 'theme-builder',
            data: {
                action: action,
                id: id,
                title: title,
                type: type,
                location: location,
                _wpnonce: window.OpsScriptData.nonce
            },
            method: 'post',
            dataType: 'json',
        }).done(function(response) {
            window.OPDashboard.Helpers.notify(response.data.message, "success");

            if ($form.data('redirectUrl')) {
                window.location.replace($form.data('redirectUrl'));
            } else {
                window.location.reload();
            }
        }).fail(function(response) {
            window.OPDashboard.Helpers.notify(response.responseJSON.message, "error");
        });

        return false;
    }

    /**
     * Delete Rule REST
     *
     * @param e
     * @return {Void}
     */
    delete(e) {
        e.preventDefault();

        let id = $(e.currentTarget).data('id');
        let dialogOptions = window.OP3General.dialogOptions;

        window.OP3General.confirm(
            Object.assign(dialogOptions, {
                theme: 'optimizepress',
                closeIcon: true,
                title: 'Delete',
                content: () => {
                    return '<div class="ops-container-fluid"><p style="color: #000; font-size: 1.6rem;">Are you sure you want to delete this item?</p></div>'
                },
                buttons: {
                    confirm: {
                        text: "Delete",
                        btnClass: 'opui-btn opui-btn-danger opui-float-right',
                        action: function() {
                            this.$$confirm.prop('disabled', true);
                            this.$$confirm.html('<span style="display: inline-block !important" class="opui-spinner opui-spinner-border opui-text-light opui-mr-2"></span> Deleting ...');

                            $.ajax({
                                url: OpsScriptData.opd_api_url + 'theme-builder/delete',
                                data: {
                                    id: id,
                                    _wpnonce: window.OpsScriptData.nonce
                                },
                                method: 'post',
                                dataType: 'json',
                            }).done(function(response) {
                                window.OPDashboard.Helpers.notify(response.data.message, "success");
                                location.reload();
                            }).fail(function(response) {
                                window.OPDashboard.Helpers.notify(response.responseJSON.message, "error");
                            });
                            return false;
                        }
                    }
                }
            })
        );
    }
}